export default __webpack_public_path__ + "static/media/files.1cfaecb4.svg";